var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdultEducation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/AOI-Education/Adult-Education/Active/48px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/AOI-Education/Adult-Education/Active/48px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adult-Education",
    transform: "translate(4.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2727273,26.5 L1.10436309,26.5 C0.4940128,26.5 0,26.207 0,25.846 L0,24.5 L22.2727273,24.5 L40,24.5 L40,25.8453273 C40,26.2061469 39.45735,26.5 38.7869087,26.5 L22.2727273,26.5 Z",
    id: "Combined-Shape",
    fill: "#001823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,0.5 L4.5,24.5 L35.5,24.5 L35.5,0.5 L4.5,0.5 Z M4,-0.5 L36,-0.5 C36.2761424,-0.5 36.5,-0.276142375 36.5,0 L36.5,25 C36.5,25.2761424 36.2761424,25.5 36,25.5 L4,25.5 C3.72385763,25.5 3.5,25.2761424 3.5,25 L3.5,0 C3.5,-0.276142375 3.72385763,-0.5 4,-0.5 Z",
    id: "Rectangle",
    fill: "#001823",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#001823",
    x: 14,
    y: 5.5,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#001823",
    x: 14,
    y: 17.5,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#DB3725",
    x: 14,
    y: 11.5,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,8.5 C8.61928813,8.5 7.5,7.38071187 7.5,6 C7.5,4.61928813 8.61928813,3.5 10,3.5 C11.3807119,3.5 12.5,4.61928813 12.5,6 C12.5,7.38071187 11.3807119,8.5 10,8.5 Z M10,7.5 C10.8284271,7.5 11.5,6.82842712 11.5,6 C11.5,5.17157288 10.8284271,4.5 10,4.5 C9.17157288,4.5 8.5,5.17157288 8.5,6 C8.5,6.82842712 9.17157288,7.5 10,7.5 Z",
    id: "Oval",
    fill: "#001823",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,20.5 C8.61928813,20.5 7.5,19.3807119 7.5,18 C7.5,16.6192881 8.61928813,15.5 10,15.5 C11.3807119,15.5 12.5,16.6192881 12.5,18 C12.5,19.3807119 11.3807119,20.5 10,20.5 Z M10,19.5 C10.8284271,19.5 11.5,18.8284271 11.5,18 C11.5,17.1715729 10.8284271,16.5 10,16.5 C9.17157288,16.5 8.5,17.1715729 8.5,18 C8.5,18.8284271 9.17157288,19.5 10,19.5 Z",
    id: "Oval-Copy",
    fill: "#001823",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#DB3725",
    cx: 10,
    cy: 12,
    r: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultEducation);
export default __webpack_public_path__ + "static/media/AdultEducation.b8dc427c5e71c93ea80ccae441a46bfa.svg";
export { ForwardRef as ReactComponent };